import { Component, ElementRef, inject, input, viewChild, ChangeDetectionStrategy } from '@angular/core';
import { RouterLink, RouterLinkActive } from '@angular/router';
import { heroXMark } from '@ng-icons/heroicons/outline';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { AsyncPipe } from '@angular/common';
import { ProfilePictureComponent } from '@app/shared/components/profile-picture/profile-picture.component';
import { NotificationCenterComponent } from '@app/shared/notification-center/notification-center.component';
import { SkillCertificateConfirmationComponent } from '@app/shared/skill-certificate-confirmation/skill-certificate-confirmation.component';
import { ProfileDropdownComponent } from '@app/shared/components/profile-dropdown/profile-dropdown.component';
import { TreeViewDataService } from '@app/core/services/tree-view.data.service';
import { EmployeeApi } from '@app/core/services/employee.api';

@Component({
  selector: 'if-header',
  templateUrl: './header.component.html',
  imports: [
    RouterLink,
    RouterLinkActive,
    ProfilePictureComponent,
    NotificationCenterComponent,
    SkillCertificateConfirmationComponent,
    ProfileDropdownComponent,
    NgIcon,
    AsyncPipe,
  ],
  changeDetection: ChangeDetectionStrategy.Eager,
  viewProviders: [provideIcons({ heroXMark })],
})
export class HeaderComponent {
  readonly profile = viewChild.required<ElementRef<any>>('profile');
  readonly dropdown = viewChild.required<ElementRef<any>>('dropdown');
  readonly adminLabel = input<boolean>(false);

  protected readonly viewDataService = inject(TreeViewDataService);

  protected readonly hasSubordinates$ = inject(EmployeeApi).hasCurrentUserSubordinates();
}
